<template>
  <div class="ResultForm">
    <ANumberKey @completed="handleCompleted" />
    <div class="row-splitter">
      <el-button type="primary" class="button" @click="handleClickRegister">수량 등록</el-button>
      <el-button
        class="button"
        @click="closeDialog"
      >{{$t('button.close')}}(Esc)</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ResultForm",
  data() {
    return {
      value: 0,
    }
  },
  methods: {
    handleCompleted(val) {
      this.value = val;
    },
    closeDialog() {
      this.$emit('completed');
    },
    handleClickRegister() {
      this.$emit('completed', this.value);
    },
  },
}
</script>

<style lang="scss" scoped>
.button { width: 46%; }
</style>

